import React, { useEffect, useState } from 'react';
import { Menu, Search, User } from 'lucide-react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md border-b border-stone-200' : 'bg-transparent'}`} data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between" data-id="element-62">
        <div className="flex items-center gap-8" data-id="element-63">
          <a href="#" className="text-xl font-bold tracking-widest uppercase text-charcoal-900" data-id="element-64">
            Aura
          </a>
          <div className="hidden md:flex gap-6 text-sm font-medium tracking-wide text-charcoal-600" data-id="element-65">
            <a href="#" className="hover:text-charcoal-900 transition-colors" data-id="element-66">
              Buy
            </a>
            <a href="#" className="hover:text-charcoal-900 transition-colors" data-id="element-67">
              Sell
            </a>
            <a href="#" className="hover:text-charcoal-900 transition-colors" data-id="element-68">
              Off-Market
            </a>
          </div>
        </div>

        <div className="flex items-center gap-6 text-charcoal-900" data-id="element-69">
          <button className="hidden md:flex items-center gap-2 text-sm font-medium tracking-wide hover:opacity-70 transition-opacity" data-id="element-70">
            <User size={18} data-id="element-71" />
            <span data-id="element-72">Sign In</span>
          </button>
          <button className="p-2 hover:bg-black/5 rounded-full transition-colors" data-id="element-73">
            <Menu size={24} data-id="element-74" />
          </button>
        </div>
      </div>
    </motion.nav>;
}